//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/AME.js";
SPLM.AME.ProgrammingLanguage = Object.freeze({
    "Db" : "Db", "Stl" : "Stl", "Lad" : "Lad", "Fbd" : "Fbd", "Scl" : "Scl", "Unknown" : "Unknown"});

SPLM.AME.ConstantType = Object.freeze({
    "Bool" : "Bool", "Byte" : "Byte", "Word" : "Word", "Dword" : "Dword", "Int" : "Int", "Dint" : "Dint", "Aref" : "Aref", "Unknown" : "Unknown"});

SPLM.AME.InterfaceAccessType = Object.freeze({
    "Undef" : "Undef", "Bool" : "Bool", "Byte" : "Byte", "Word" : "Word", "Int" : "Int", "Dint" : "Dint", "Time" : "Time", "Struct" : "Struct", "BlockDb" : "BlockDb", "Any" : "Any", "Unknown" : "Unknown"});

export default SPLM;